import { useInstance } from "@meraki-internal/react-dependency-injection";
import { useParams } from "react-router-dom";
import { LightHeader } from "../HeaderAndNavigationBar";
import { IonButton, IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonContent, IonPage } from "@ionic/react";
import { ClubsState, ClubState } from "./ClubsState";
import { useSubscription } from "@meraki-internal/state";
import { VolunteerList } from "../volunteers/VolunteerList";
import { ClubStateContainerContext } from "./ClubStateContainerContext";

/**
 * Make it Work
 * - [x] titles
 * - [x] api can delete
 * - [x] ui can delete
 * - [x] add form
 * - [x] edit form
 * - [ ] can close
 * - [ ] syncs to website (without email)
 *
 * Make it Right
 * - [ ] volunteer card looks good
 * - [ ] use it in all places
 * - [ ] have to confirm delete
 * - [ ] cannot delete if part of more than one club (just removes)
 * - [ ] can remove without delete
 * - [ ] can be part of more than one club
 * - [ ] can only delete / remove from your club
 * - [ ] non club admins can edit themselves
 *
 * 5 minutes
 */


const ClubStateContext: React.FC<{ clubId: string; children: React.ReactElement; }> = ({ clubId, children}) => {
    const clubs = useInstance(ClubsState);
    useSubscription(() => clubs);
    const club = clubs.maybeGetClub(clubId);

    if (!club){
        return null;
    }
    return (
        <ClubStateContainerContext clubId={clubId}>
            {children}
        </ClubStateContainerContext>
    );
}

export const ClubPage: React.FC = () => {
    let { clubId } = useParams();

    return (
        <ClubStateContext clubId={clubId!}>
            <InnerClubPage />
        </ClubStateContext>
    )
};

const InnerClubPage: React.FC = () => {
    const club = useInstance(ClubState).getClub()

    return (
        <IonPage>
            <LightHeader title={`${club.name} Admin `} />
            <IonContent>
                <IonCard>
                    <IonCardHeader>
                        <IonCardTitle>Club Health </IonCardTitle>
                    </IonCardHeader>
                    <IonButton href={`/#/clubs/${club.clubId}/health/edit`} fill="outline">Edit</IonButton>
                </IonCard>
                <IonCard>
                    <IonCardHeader>
                        <IonCardTitle>Volunteers </IonCardTitle>
                        <IonCardContent>
                            <VolunteerList clubId={club.clubId} />
                        </IonCardContent>
                    </IonCardHeader>
                </IonCard>
                <IonCard>
                    <IonCardHeader>
                        <IonCardTitle>More Coming Soon</IonCardTitle>
                    </IonCardHeader>
                </IonCard>
            </IonContent>
        </IonPage>
    )
};